import { Component } from '@angular/core';
import { ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-community';
import moment from 'moment';

@Component({
  selector: 'app-customers-closed-arb-orders',
  templateUrl: './customers-closed-arb-orders.component.html',
  styleUrls: ['./customers-closed-arb-orders.component.scss'],
})
export class CustomersClosedArbOrdersComponent {
  gridOptions: GridOptions;
  columnDefs: ColDef[];
  frameworkComponents;
  context;
  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;

  loading: boolean = false;

  constructor() {
    this.context = { componentParent: this };
    this.gridOptions = this.gridOptionsData();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    const sortModel = [{ colId: 'dateTime', sort: 'desc' }];
  }
  gridOptionsData() {
    return {
      defaultColDef: {
        resizable: true,
        sortable: true,
        width: 150,
        cellClass: 'cell-class ag-right-aligned-cell',
        headerClass: 'header-class ag-left-aligned-header',
      },
      columnDefs: [
        {
          headerName: 'ACTION',
          width: 100,
          cellRenderer: 'actionRenderer',
          cellStyle: { 'text-align': 'center' },
        },
        {
          headerName: 'ORDER N0',
          width: 150,
          field: 'orderNumber',
          cellStyle: { 'text-align': 'right' },
        },

        {
          headerName: 'INVOICE N0',
          width: 150,
          field: 'customerNumber',
          cellStyle: { 'text-align': 'right' },
        },
        {
          headerName: 'REFERENCE',
          width: 200,
          field: 'reference',
          cellStyle: { 'text-align': 'left' },
        },

        {
          headerName: 'DATE SUPPLIED',
          width: 180,
          field: 'dateTime',
          valueFormatter: this.dateFormatter,
          cellStyle: { 'text-align': 'left' },
        },
      ],
    };
  }
  dateFormatter(params) {
    return moment(params.value).format('L <HH:mm>');
  }
}
